import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const PoliciesList = lazy(() => import("../../container/pages/policies/index"));

const NewPolicy = lazy(() => import("../../container/pages/policies/new"));

const EditPolicy = lazy(() => import("../../container/pages/policies/edit"));

function PoliciesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/edit/:id`} component={EditPolicy} />
      <Route path={`${path}/new`} component={NewPolicy} />
      <Route path={`${path}`} component={PoliciesList} />
    </Switch>
  );
}

export default PoliciesRoute;
